<div class="ai-answer" [ngClass]="{'failed-content' : value?.failed}">
    <div class="avatar-ai"></div>
    <div *ngIf="value.answer === ''; else readyAnswer">
        <div class="loading">
            <span class="loading_dot"></span>
            <span class="loading_dot"></span>
            <span class="loading_dot"></span>
        </div>
    </div>
    <ng-template #readyAnswer>
        <div class="content"  [innerHTML]="value.answer">{{value.answer}}</div>
    </ng-template>
</div>
